import { render, staticRenderFns } from "./SuccessDeliveredPerformMails.vue?vue&type=template&id=1d7b7dd0&scoped=true"
import script from "./SuccessDeliveredPerformMails.vue?vue&type=script&lang=js"
export * from "./SuccessDeliveredPerformMails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7b7dd0",
  null
  
)

export default component.exports